import Backbone from "backbone";
import $ from "jquery";

import * as accountModal from "accountModal";
import * as modalDialog from "modalDialog";
import UserModel from "models/UserModel";
import models from "models/models";
import * as emailNotifications from "notificationUtils";
import readlangClient from "readlangClient";
import * as dateUtils from "shared/dateUtils";
import * as languageMap from "shared/languageMap";
import * as splitTest from "splitTest";

class EmailReminderAndStreakRepairView extends Backbone.View<UserModel> {
  models: {
    streak: any;
    user: any;
  };

  autoShow: boolean;

  constructor(options) {
    super(options);

    this.models = options.models;
    this.autoShow = options.autoShow ?? false;
    this.render();
  }

  render() {
    if (this.models.streak.get("repairableDays") > 0) {
      const streakRepairs = this.models.user.get("streakRepairs");
      if (!this.models.user.hasPremiumAccess()) {
        this.$el.html(`
          <div class="callout">
          ⚠️ You lost a ${this.models.streak.get(
            "repairableDays"
          )} streak yesterday. <a target="_blank" href="/account" class="upgradeLink">Upgrade to Premium</a> to repair it!
          </div>`);
        splitTest.trackEventWithProperties("showStreakRepairUpsell", {
          "Automatically Shown": this.autoShow,
        });
        return this;
      } else if (streakRepairs > 0) {
        this.$el.html(`
          <div class="callout">
          ⚠️ You lost a ${this.models.streak.get(
            "repairableDays"
          )} streak yesterday. But
          you still have ${streakRepairs} streak repair${
            streakRepairs === 1 ? "" : "s"
          } left this month!
          <div style="margin-top:10px">
          <button class="repairStreak">Use Streak Repair</button>
          </div>
          </div>`);
        splitTest.trackEventWithProperties("showStreakRepairCallout", {
          "Automatically Shown": this.autoShow,
        });
        return this;
      }
    }

    if (
      !emailNotifications.has(
        "dailyReminder",
        this.models.user.get("currentLearningLanguage")
      )
    ) {
      this.$el.html(`
      <div class="callout">
        <label><input id="dailyReminderCheckbox" type="checkbox" name="dailyReminder"
            style="margin-left:0"
          ></input>
          Email me a daily reminder to help me keep my streak.
        </label>
      </div>`);

      return this;
    }

    // No need to render anything
    return this;
  }

  clickCheckbox(event) {
    event.stopPropagation();

    const checked = this.$el.find('input[name="dailyReminder"]').is(":checked");

    if (checked) {
      emailNotifications.addType("dailyReminder");
      modalDialog.cancelAll();
      modalDialog.show(
        $(`
          <div class="centralDialog">
            <h2>Daily ${
              languageMap.map[this.models.user.get("currentLearningLanguage")]
                .english
            } Reminder Created</h2>
            <p>
              You'll receive an email each day that you don't practice, encouraging you to continue.
            </p>
            <p>
              <small>You can alter this setting and/or add push notifications, from the
              <a id="settingsPageLink" href="/settings">Settings Page</a>.</small>
            </p>
          </div>`)
      );

      $("#settingsPageLink").click(() => {
        if (window.location.pathname === "/settings") {
          // Just dismiss the dialog if we're already on the settings page
          modalDialog.cancelAll();
        }
      });
    } else {
      emailNotifications.removeType("dailyReminder");
    }
  }

  repairStreak() {
    this.$el.find(".repairStreak").prop("disabled", true);

    readlangClient.request(
      "POST",
      "/api/userLearningLog/repairStreak",
      { timezoneOffset: dateUtils.getTimezoneOffset() },
      async () => {
        // Cancel all notifications. This assumes that the only notifications we have are the
        // streak related ones. If this ever changes in future we'd need to revisit this.
        await models.storedNotifications?.deleteAllStoredNotifications();

        // Reload the page to update the streak
        window.location.reload();
      },
      (error) => {
        alert("Error repairing streak: " + error);
      }
    );
  }

  upgrade(event) {
    event.preventDefault();
    event.stopPropagation();

    accountModal.show({
      model: this.models.user,
      title: "streakRepairUpsell",
      messageHtml: "<h2>Go premium for streak repair and more...</h2>",
      showTitle: false,
      // onCancel: function () {
      //   models.user.save({ readerWordHighlights: "off" }, { patch: true });
      // },
    });
  }

  events(): Backbone.EventsHash {
    return {
      'click input[name="dailyReminder"]': "clickCheckbox",
      "click .repairStreak": "repairStreak",
      "click .upgradeLink": "upgrade",
    };
  }
}

export default EmailReminderAndStreakRepairView;
